// swiper-multi.js
document.addEventListener('DOMContentLoaded', () => {
  // ページ内のすべての .mySwiper を取得
  document.querySelectorAll('.mySwiper').forEach((rootEl, i) => {
    // 各スライダー専用のナビゲーションボタンを取得
    const nextEl = rootEl.querySelector('.swiper-button-next');
    const prevEl = rootEl.querySelector('.swiper-button-prev');

    // Swiperを初期化
    new Swiper(rootEl, {
      slidesPerView: 'auto',
      centeredSlides: true,
      loop: true,
      spaceBetween: 30,
      watchSlidesProgress: true,

      // 各スライダー内のボタンを使う
      navigation: nextEl && prevEl ? { nextEl, prevEl } : undefined,

      on: {
        progress: function () {
          const scaleStep = 0.2; // 縮小の度合い
          const slides = this.slides;

          for (let i = 0; i < slides.length; i++) {
            const slide = slides[i];
            const progress = slide.progress;
            const scale = 1 - Math.min(Math.abs(progress * scaleStep), scaleStep * 2);

            // 透過を常に1（不透明）
            slide.style.transform = `scale(${scale})`;
            slide.style.opacity = 1;
            slide.style.zIndex = 999 - Math.abs(progress * 10);
          }
        },
        setTransition: function (speed) {
          this.slides.forEach(slide => {
            slide.style.transition = `${speed}ms`;
          });
        }
      }
    });
  });
});
